import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import BigCLoading from "../components/Loading";

/*const Lineconnect = () => {
  useEffect(async () => {
    async function fetchData() {
      const allPathName = window.location.pathname;
      const pathName = allPathName.substring(13); // out --> /line-connect
      const searchParam = window.location.search;
      //console.log(pathName);
      ///console.log(searchParam);
      if (isMobile) {
        window.location.href = `line://app/${process.env.REACT_APP_LINE_CONNECT_LIFF_ID}${pathName}${searchParam}`;
      } else {
        window.location.href = `https://liff.line.me/${process.env.REACT_APP_LINE_CONNECT_LIFF_ID}${pathName}${searchParam}`;
      }
    }
    //   https://bigc-line-liff-redirect.web.app/line-connect?feature=register&utm_source=Standee_Store&utm_medium=organic&utm_campaign=>PV:DMK>DA:20240726>AN:->OB:VIEW>FM:Photo>FT:Line_Connect_Menu>CN:crm_campaign>PT:Line_Connect
    //   localhost:3001/line-connect?feature=register&utm_source=Standee_Store&utm_medium=organic&utm_campaign=>PV:DMK>DA:20240726>AN:->OB:VIEW>FM:Photo>FT:Line_Connect_Menu>CN:crm_campaign>PT:Line_Connect
    fetchData();
  }, []);
  return <></>;
};*/


//https://bigc-dmkt-link.web.app/line-connect/bc-coupons/RWD_913557?utm_source=line-connect
const Lineconnect = () => {
  useEffect(() => {
    const fullPath = window.location.pathname;          // ex: /line-connect/game/supergirls
    const searchParam = window.location.search || "";   // utm
    const liffId = process.env.REACT_APP_LINE_CONNECT_LIFF_ID;

    // ตัดคำว่า /line-connect ออก
    const redirectPath = fullPath.replace("/line-connect", "") || "/";

    // ===== มือถือ: เปิดผ่าน LINE deep link =====
    const mobileUrl = `line://app/${liffId}?liff.state=${encodeURIComponent(
      redirectPath + searchParam
    )}`;

    // ===== Desktop: เปิดผ่าน browser normal LIFF url =====
    const desktopUrl = `https://liff.line.me/${liffId}${redirectPath}${searchParam}`;

    if (isMobile) {
      window.location.href = mobileUrl;
    } else {
      window.location.href = desktopUrl;
    }
  }, []);

  return null;
};

export default Lineconnect;
